export function isHeicFile(file: File): boolean {
  return (
    file.type === 'image/heic' ||
    file.type === 'image/heif' ||
    file.name.toLowerCase().endsWith('.heic') ||
    file.name.toLowerCase().endsWith('.heif')
  );
}

const SUPPORTED_FORMATS = [
  'image/jpeg',
  'image/png',
  'image/heic',
  'image/heif',
];

export function isSupportedFormat(file: File): boolean {
  return SUPPORTED_FORMATS.includes(file.type) || isHeicFile(file);
}

function getExtension(filename: string): string {
  const parts = filename.split('.');
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
}

/**
 * @example
 * generateOutputFilename('photo.heic') // 'photo_square.jpg'
 * generateOutputFilename('vacation.png') // 'vacation_square.png'
 */
export function generateOutputFilename(originalFilename: string): string {
  const nameWithoutExt = originalFilename.split('.').slice(0, -1).join('.');

  const ext = getExtension(originalFilename);

  /* HEIC 與 HEIF 轉為 JPEG，其餘格式保留原副檔名 */
  const finalExt = ext === 'heic' || ext === 'heif' ? 'jpg' : ext || 'jpg';

  return `${nameWithoutExt}_square.${finalExt}`;
}

/**
 * @example
 * generatePhotoId() // 'photo_1712959223450_a1b2c3d4'
 */
export function generatePhotoId(): string {
  const timestamp = Date.now();
  const randomStr = Math.random().toString(36).substring(2, 10);
  return `photo_${timestamp}_${randomStr}`;
}
